<template>
    <div class="content-page">
        <div class="left-part">
            <div class="coupon-data padding20">
                <div style="width:65%">
                    <div class="flex-row-start">
                        <div><img :src="circleImg" class="circleImg" /></div>
                        <div class="data-title">券数据</div>
                    </div>
                    <div class="pt35 lengendSize">
                        <div class="flex-row-start">
                            <div class="circle red"></div>
                            <div class="pl5 pr10">核销数量</div>
                            <div>{{couponList.writeoffNum}}</div>
                        </div>
                        <div class="flex-row-start pt10">
                            <div class="circle deepBlue"></div>
                            <div class="pl5 pr10">领取数量</div>
                            <div>{{couponList.receiveNum}}</div>
                        </div>
                    </div>
                </div>
                <div id="couponMain"></div>
            </div>
            <div class="composite-data flex-row-start padding20">
                <div style="width:65%">
                    <div class="flex-row-start">
                        <div><img :src="circleImg" class="circleImg" /></div>
                        <div class="data-title">综合评分</div>
                    </div>
                    <div class="totalNum" style="padding-top:6px;box-sizing:border-box;width:150px">{{totalCommonNum}}人评价</div>
                    <div class="rate-legend lengendSize pt35">
                        <div class="rate-legend" v-for="item in commonNumList" :key="item.shopScore">
                            <div class="circle" 
                                :class="{
                                    red: item.shopScore == 1,
                                    orange: item.shopScore == 2,
                                    blue: item.shopScore == 3,
                                    deepBlue: item.shopScore == 4,
                                    purple: item.shopScore == 5
                                }"
                            ></div>
                            <div class="pl5 pr10">{{item.shopScore}}星</div>
                            <div class="pr10">{{item.commentNum}}</div>
                        </div>
                    </div>
                </div>
                <div id="totalRateMain"></div>
            </div>
            <div class="member-data padding20">
                <div class="flex-row-between">
                    <div class="flex-row-start">
                        <div><img :src="circleImg" class="circleImg" /></div>
                        <div class="data-title">会员数据</div>
                    </div>
                    <div class="sale-date flex-row-start">
                        <div class="item" :class="{ active: item.id == chooseIds }" v-for="item in dateList1" :key="item.id" @click="onClickDates(item.id)">
                            {{item.name}}
                        </div>
                    </div>
                </div>  
                <div class="memberNum-change">
                    <div class="flex-column-around change-area" v-for="item in memberChangeList" :key="item.operateName">
                        <div class="memberNum">{{item.memberNum}}</div>
                        <div class="operateName">{{item.operateName}}</div>
                    </div>
                </div>
                <div class="newAdd-echarts">
                    <div id="memberMain"></div>
                </div>
            </div>
        </div>
        <div class="center-part">
            <div class="shop-header flex-row-between">
                <div class="flex-row-start">
                    <div class="shopName over-hidden">{{shopInfo.shopName}}</div>
                    <!-- <div class="shopAddress">上塘店</div> -->
                </div>
                <div class="flex-row-start">
                    <div v-if="isOwn">
                        <img src="@/assets/img/login/weihuo.png" alt="" class="weihuoImg">
                    </div>
                    <div class="shopNames">经营驾驶舱</div>
                </div>
                <div>
                    <div class="date">{{today}}  {{week}}</div>
                    <div class="time">{{time}}</div>
                </div>
            </div>
            <div class="shop-data">
                <div class="flex-column-around" v-for="item in list" :key="item.name">
                    <div class="turnover">{{item.turnover}}</div>
                    <div class="money">{{item.name}}</div>
                </div>
            </div>
            <div class="data-exhibixion">
                <div v-if="ids == 1" style="background: #0F1836;">
                    <div class="table-status">
                        <div class="tableNum" :class="{free: item.status == 0, checkOut: item.status == 3, occupy: item.status == 1 || item.status == 2, reserve: item.status == 100}" v-for="item in tableList" :key="item.shoppingTableId">{{item.tableName}}</div>
                    </div>
                    <div class="flex-row-between">
                        <div class="total-tableNum">全部桌位：{{tableList.length}}个</div>
                        <div class="table-status1">
                            <div class="status free">空闲</div>
                            <div class="status checkOut">结账</div>
                            <div class="status occupy">占用</div>
                            <div class="status reserve">预约</div>
                        </div>
                    </div>
                </div>
                <div v-if="ids == 2" class="flex-row-between" style="background: #020719;">
                    <div class="box">
                        <div class="goodsCase flex-row-start" v-for="item in orderList1" :key="item.id">
                            <div style="color:#5783BD;" class="with20 over-hidden">{{item.orderStatusName}}</div>   
                            <div class="with65"><el-progress :text-inside="true" :stroke-width="20" :percentage="(Math.round(item.orderNum / total * 100) / 100) * 100"></el-progress></div>
                            <div class="with15" style="text-align:right">{{item.orderNum}}</div>
                        </div>
                    </div>
                    <div class="box1">
                        <div class="goodsCase flex-row-start" v-for="(item, index) in orderList" :key="item.mallOrderId" :class="{ bg: index % 2 == 0 }">
                            <div class="with10">#{{item.orderNum}}</div>
                            <div class="with40 over-hidden">{{item.createTime}}</div>
                            <div class="with15">
                                <!-- {{
                                    item.orderStatus == 10 ? '待付款'
                                    : item.orderStatus == 19 ? '待接单'
                                    : item.orderStatus == 20 ? '待发货'
                                    : item.orderStatus == 30 ? '待确认'
                                    : item.orderStatus == 31 ? '待买单'
                                    : item.orderStatus == 35 ? '待评论'
                                    : item.orderStatus == 40 ? '已完成'
                                    : item.orderStatus == '-10' ? '已关闭'
                                    : item.orderStatus == '-20' ? '已取消'
                                    : item.orderStatus == '-21' ? '申请退款'
                                    : item.orderStatus == '-50' ? '退款'
                                    : item.orderStatus == '-60' ? '成团'
                                    : ''
                                }} -->
                                {{ orderType[item.orderStatus].title }}
                            </div>
                            <div class="with35 over-hidden">{{item.productSubject}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="method-toggle">
                <div class="item" :class="{ active: ids == item.id }" v-for="item in methodsList" :key="item.id" @click="toggleMethod(item.id)">
                    {{item.name}}
                </div>
            </div>
            <div class="data-echarts">
                <div class="sale-data">
                    <div class="flex-row-start">
                        <div><img :src="circleImg" class="circleImg" /></div>
                        <div class="data-title">桌位状态</div>
                    </div>
                    <div id="tableStatusMain"></div>
                </div>
                <div class="sale-data">
                    <div class="flex-row-between">
                        <div class="flex-row-start">
                            <div><img :src="circleImg" class="circleImg" /></div>
                            <div class="data-title">销售数据</div>
                        </div>
                        <div class="sale-date flex-row-start">
                            <div class="item" :class="{ active: item.id == chooseId }" v-for="item in dateList" :key="item.id" @click="onClickDate(item.id)">
                                {{item.name}}
                            </div>
                        </div>
                    </div>  
                    <div class="totalNum">总计：{{totalSaleNum}}笔</div>
                    <div class="sale-records">
                        <div class="sale-goods" v-for="(item, index) in saleGoodsList" :key="item.id">
                            <div class="sequenceNum">{{index + 1 }}</div>
                            <div class="flex-row-between" style="width:70%">
                                <div class="over-hidden">{{item.goodsName}}</div>
                                <div>{{item.saleNum}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sale-data">
                    <div class="flex-row-start pb10">
                        <div><img :src="circleImg" class="circleImg" /></div>
                        <div class="data-title">库存预警</div>
                    </div>
                    <div class="flex-row-between table-header">
                        <div>商品名</div>
                        <div>库存量</div>
                    </div>
                    <div class="sale-records">
                        <div class="sale-goods flex-row-between sale-goods1" v-for="item in goodsStockWarnList" :key="item.id">
                            <div class="over-hidden">{{item.goodsName}}</div>
                            <div>{{item.totalStockCount}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-part">
            <div class="gathering-data padding20">
                <div class="flex-row-start">
                    <div><img :src="circleImg" class="circleImg" /></div>
                    <div class="data-title">收款趋势</div>
                </div>
                <div id="gatheringMain"></div>
            </div>
            <div class="trend-chart padding20">
                <div class="flex-row-start">
                    <div><img :src="circleImg" class="circleImg" /></div>
                    <div class="data-title">订单趋势</div>
                </div>
                <div id="orderMain"></div>
            </div>
            <div class="trend-chart padding20">
                <div class="flex-row-start">
                    <div><img :src="circleImg" class="circleImg" /></div>
                    <div class="data-title">访问趋势</div>
                </div>
                <div id="visitMain"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { mapState } from "vuex";
import { 
    getFindReceiveOrWriteOffStatictic,
    getStatisticsComments,
    getShopMemberData,
    getFindDailyNewShopMemberNum,
    getFindTopGoodsV2,
    getFindGoodsByTotalStockCount,
    getAccessRecordForStatistics,
    getStatisticsOrders,
    getStatisticsOrdersByDates,
    getOrderNumsByStatus,
    getAllOrdersSimple,
    getEdcShopTablesNumsV2,
    getShopTablesForCockpit
} from "../api/index"
export default {
    data() {
        return {
            shopInfo: {},
            circleImg: require('@/assets/img/login/circle.png'),
            list: [],
            methodsList: [
                { id: 1, name: "堂食" },
                { id: 2, name: "外卖" }
            ],
            ids: 1,
            chooseId: 1,
            dateList: [
                { id: 1, name: "日" },
                { id: 2, name: "月" }
            ],
            chooseIds: 1,
            dateList1: [
                { id: 1, name: "日" },
                // { id: 2, name: "周" }
            ],
            saleGoodsList: [
                { id: 1, goodsName: "糖醋排骨" },
                { id: 2, goodsName: "干锅包菜" },
                { id: 3, goodsName: "玉米排骨汤" },
                { id: 4, goodsName: "番茄炒蛋" },
                { id: 5, goodsName: "辣子鸡丁" },
                { id: 6, goodsName: "红烧猪蹄" },
                { id: 7, goodsName: "茄子豆角" }
            ],
            goodsStockWarnList: [],
            memberChangeList: [],
            tableList: [],
            echartsPie: "",
            tableStatusEchartsPie: "",
            totalRateEchartsPie: "",
            option: {
                tooltip: {
                    trigger: 'item'
                },
                legend: {},
                color:['#FF3B30','#69E2E1', '#6001FF', '#418DE2'], 
                title: {},
                graphic: {},
                series: []
            },
            orderEchartsPie: "",
            orderOption: {
                xAxis: {
                    type: 'category',
                    show: true, //不显示坐标轴线、坐标轴刻度线和坐标轴上的文字
                    data: [],
                    axisLabel: {
                        show: true,
                        textStyle: {
                           color: '#fff',  //更改坐标轴文字颜色
                           fontSize : 14      //更改坐标轴文字大小
                        },
                        interval:0,  
                        rotate:40
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine:{
                        lineStyle:{
                           color:'#0F1836' //更改坐标轴颜色
                        }
                    }
                },
                yAxis: {
                    axisTick:{
                        show: false //不显示坐标轴刻度线
                    },
                    axisLine: {
                        show: false, //不显示坐标轴线
                    },
                    axisLabel: {
                        show: false, //不显示坐标轴上的文字
                    },
                    splitLine: {     //网格线
                      "show": false
                    }
                },
                series: []
            },
            polylineEcharts: "",
            polylineEcharts1: "",
            polylineOption: {
                xAxis: {
                    type: 'category',
                    show: true, //不显示坐标轴线、坐标轴刻度线和坐标轴上的文字
                    data: [],
                    axisLabel: {
                        show: true,
                        textStyle: {
                           color: '#fff',  //更改坐标轴文字颜色
                           fontSize : 14      //更改坐标轴文字大小
                        },
                        interval:0,  
                        rotate:40
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine:{
                        lineStyle:{
                           color:'#0F1836' //更改坐标轴颜色
                        }
                    }
                },
                yAxis: {
                    axisTick:{
                        show: false //不显示坐标轴刻度线
                    },
                    axisLine: {
                        show: false, //不显示坐标轴线
                    },
                    axisLabel: {
                        show: false, //不显示坐标轴上的文字
                    },
                    splitLine: {     //网格线
                      "show": false
                    }
                },
                series: [
                    {
                        data: [],
                        type: 'line',
                        label: {   //  显示数值
                            show: true,
                            position: 'top',
                            color: '#fff',
                            fontSize: 14,
                            fontWeight: 500
                        },
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#418DE2'
                            }, {
                                offset: 1,
                                color: '#3AAFE7'
                            }])
                        }
                    }
                ]
            },
            couponEchartsPie: "",
            clientWidth: document.body.clientWidth,
            sevenDate: "",
            nowDate: "",
            couponList: {
                receiveNum: "",
                writeoffNum: ""
            },
            commonNumList: [],
            totalCommonNum: 0,
            shopMemberData: {},
            totalSaleNum: 0,
            statisticsOrders: {},
            tableStatusNum: [],
            payMethodList: [],
            totalAccount: 0,
            scoreRate: 0,
            today: "",
            week: "",
            time: "",
            timer: null,
            orderList: [],
            orderList1: [],
            orderType: {
                10: {
                  title: "待付款"
                },
                19: {
                  title: "待接单"
                },
                20: {
                  title: "待发货"
                },
                30: {
                  title: "待确认"
                },
                31: {
                  title: "待买单"
                },
                35: {
                  title: "待评论"
                },
                40: {
                  title: "已完成"
                },
                // "-10": {
                //   title: "已关闭"
                // },
                "-20": {
                  title: "已取消"
                },
                "-21": {
                  title: "申请退款"
                },
                "-50": {
                  title: "退款"
                },
                "-60": {
                    title: "未成团"
                }
            },
            total: 0,
            timer1: null,
            timer2: null
        }
    },
    computed: {
    ...mapState({
      isOwn: (state) => state.isOwn
    }),
  },
    mounted() {
        console.log(this.isOwn, 'isOwn')
        this.shopInfo = JSON.parse(localStorage.getItem('shopInfo'))
        console.log(this.shopInfo, "shopInfo")
        let that = this
	    window.onresize =() =>{
            return (()=>{
                window.clientWidth = document.body.clientWidth;
                that.clientWidth = window.clientWidth;
            })()
        };
        this.fun_date(-6)
        this.getStatisticsOrders(this.sevenDate, this.nowDate)
        this.getFindTopGoodsV2s(this.nowDate, this.nowDate)
        this.timer2 = setInterval(() => {
            let that = this
            that.getStatisticsOrders(this.sevenDate, this.nowDate)
            that.getFindTopGoodsV2s(this.sevenDate, this.nowDate)
        },  600000)  //  600000

        this.timer = setInterval(() => {
            let that = this
            that.getTime()
        }, 1000)
        // console.log(this.goodsList, "goodsList")

        that.getShopTablesForCockpit()
        this.timer1 = setInterval(() => {
            let that = this
            that.getShopTablesForCockpit()
        }, 180000)
    },
    beforeDestroy() {
        this.timer = null
        clearInterval(this.timer)
        this.timer1 = null
        clearInterval(this.timer1)
        this.timer2 = null
        clearInterval(this.timer2)
    },
    watch: {
        clientWidth(newVal,oldVal){
            console.log(newVal);//浏览器窗口变化时，打印宽度。
            let that = this;
            window.addEventListener("resize", () => {
                if (that.echartsPie) {
                    that.echartsPie.resize();
                }
	    		if (that.tableStatusEchartsPie) {
                    that.tableStatusEchartsPie.resize();
                }
                if (that.totalRateEchartsPie) {
                    that.totalRateEchartsPie.resize();
                }
                if (that.orderEchartsPie) {
                    that.orderEchartsPie.resize();
                }
                if (that.polylineEcharts) {
                    that.polylineEcharts.resize();
                }
                if (that.polylineEcharts1) {
                    that.polylineEcharts1.resize();
                }
                if (that.couponEchartsPie) {
                    that.couponEchartsPie.resize();
                }
	    	})
        }
    },  
    methods: {
        getTime() {
            var date = new Date();
            var hour = date.getHours();
            var minutes = date.getMinutes(); 
            var seconds = date.getSeconds()
            let h = hour <= 9 ? '0' + hour : hour
            let m = minutes <= 9 ? '0' + minutes : minutes
            let s = seconds <= 9 ? '0' + seconds : seconds
            this.time = h + ':' + m + ':' + s
            // console.log(this.time, "time")
        },  
        fun_date(num) { 
            var date1 = new Date();
            let year = date1.getFullYear()
            let date = date1.getMonth() + 1
            let days = date1.getDate()
            if (year <= 9) {
                year = '0' + year
            }
            if (date <= 9) {
                date = '0' + date
            }
            if (days <= 9) {
                days = '0' + days
            }
            //今天时间
            this.nowDate = year + "-" + date + "-" + days
            this.today = date + "月" + days + "日"
            let day = year + "-" + date + "-" + days
            console.log(this.nowDate, "nowDate", this.today, "today", day, "day");
            this.fun_week(day)
            var date2 = new Date(date1);
            date2.setDate(date1.getDate() + num);

            let year1 = date2.getFullYear()
            let date3 = date2.getMonth() + 1
            let days1 = date2.getDate()
            if (year1 <= 9) {
                year1 = '0' + year1
            }
            if (date3 <= 9) {
                date3 = '0' + date3
            }
            if (days1 <= 9) {
                days1 = '0' + days1
            }
            //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
            this.sevenDate = year1 + "-" + date3 + "-" + days1; 
            console.log(this.sevenDate, "sevenDate");
            return this.sevenDate;
        },
        fun_week(datestr){
            var weekArray = new Array("周日", "周一", "周二", "周三", "周四", "周五", "周六");
            this.week = weekArray[new Date(datestr).getDay()];
            console.log(this.week, "this.week");
            return this.week;
        },
        // 销售排名商品  
        getFindTopGoodsV2s(startDate, endDate) {
            // this.fun_date()
            getFindTopGoodsV2({
                pageNo: 1,
                startDate: startDate,
                endDate: endDate,
                sortOrder: 'desc'
            })
            .then(res => {
                this.getFindGoodsByTotalStockCount()
                if (res.code == 1) {
                    this.totalSaleNum = 0
                    this.saleGoodsList = res.data
                    this.saleGoodsList.forEach(item => {
                        this.totalSaleNum += item.saleNum
                    })
                } else if (res.code == -1) {
                    this.saleGoodsList = []
                }
            })
        },
        // 库存预警列表
        getFindGoodsByTotalStockCount() {
            getFindGoodsByTotalStockCount({
                pageNo: 1,
            })
            .then(res => {
                this.getShopMemberData()
                if (res.code == 1) {
                    this.goodsStockWarnList = res.data
                } else if (res.code == -1) {
                    this.goodsStockWarnList = []
                }
            })
        },
        // 订单统计
        getStatisticsOrders(startDate, endDate, orderStatus, orderCategory) {
            getStatisticsOrders({
                startDate,
                endDate,
                orderStatus,
                orderCategory
            })
            .then(res => {
                this.getEdcShopTablesNumsV2()
                if (res.code == 1) {
                    this.payMethodList = []
                    this.statisticsOrders = res.data
                    let totalRetailPrice = this.statisticsOrders.totalRetailPrice ? Number(this.statisticsOrders.totalRetailPrice).toFixed(2) : 0
                    let refundMoney = this.statisticsOrders.refundMoney ? Number(this.statisticsOrders.refundMoney).toFixed(2) : 0
                    let avgPrice = this.statisticsOrders.avgPrice ? Number(this.statisticsOrders.avgPrice).toFixed(2) : 0
                    this.list = [
                        { turnover: totalRetailPrice, name: '营业额（元）' },
                        { turnover: this.statisticsOrders.orderNum || 0, name: '订单数（笔）' },
                        { turnover: refundMoney, name: '退款（元）' },
                        { turnover: avgPrice, name: '单价（元）' },
                    ]
                    this.payMethodList = [
                        {value: this.statisticsOrders.payByWechat, name: '微信'},
                        {value: this.statisticsOrders.payByAlipay, name: '支付宝'},
                        {value: this.statisticsOrders.payByMember, name: '会员支付'},
                        {value: this.statisticsOrders.payByCash, name: '现金支付'}
                    ]
                    let totalAccount = 0
                    this.payMethodList.forEach(item => {
                        totalAccount += item.value
                    })
                    this.totalAccount = totalAccount.toFixed(2) || 0
                    this.getGatheringPie()
                }
            })
        },
        toggleMethod(id) {
            this.ids = id
        },
        onClickDate(id) {
            var date = new Date();
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            let nowMonth = year + "-" + month
            // console.log(nowMonth, "nowMonth")
            var bigMonth = [1, 3, 5, 7, 8, 10, 12]
            var smallMonth = [4, 6, 9, 11]
            let day;
            if (bigMonth.includes(month)) {
                day = 31
            } else if (smallMonth.includes(month)) {
                day = 30
            } else if (month == 2) {
                if ((year % 4 == 0) && (year % 100 != 0 || year % 400 == 0)) {
                    day = 29
                } else {
                    day = 28
                }
            }

            this.chooseId = id
            // console.log(this.nowDate, "nowDate", this.sevenDate, "nowDate");
            if (this.chooseId == 1) {
                this.getFindTopGoodsV2s(this.nowDate, this.nowDate)
            } else if (this.chooseId == 2) {
                this.getFindTopGoodsV2s(`${nowMonth}-1`, `${nowMonth}-${day}`)
            }
        },
        onClickDates(id) {
            this.fun_date(-6)
            this.chooseIds = id
            // if (this.chooseIds == 1) {
            //     this.getFindDailyNewShopMemberNum(this.nowDate, this.nowDate)
            // } else {
            //     this.getFindDailyNewShopMemberNum(this.sevenDate, this.nowDate)
            // }
        },
        // 123
        getGatheringPie() {
            // if (this.echartsPie != null && this.echartsPie != "" && this.echartsPie != undefined) {
            //     this.echartsPie.dispose();//销毁
            // }
            this.option.legend = {
                // top: '5%',
                // left: 'center',
                orient: 'horizontal',
                x: 'center',
                y: 'bottom',
                // x: '135px',
                // y: '210px',
                itemWidth: 24,   // 设置图例图形的宽
                itemHeight: 18,  // 设置图例图形的高
                textStyle: {
                    color: '#5783BD'  // 图例文字颜色
                },
                data: ["微信", "支付宝", "会员支付", "现金支付"],
                itemGap: 30,  //  置各个item之间的间隔，单位px，默认为10，横向布局时为水平间隔，纵向布局时为纵向间隔
            }
            this.option.title = {
                text: this.totalAccount,
                left:'center',
                top:'38%',
                textStyle:{
                  color:'#fff',
                  fontSize: 20,
                  align:'center'
                }
            }
            this.option.graphic = {       // 图形中间文字
                type:"text",
                left:"center",
                top:"50%",
                style:{
                    text:"总额（元）",
                    textAlign:"center",
                    fill:" #5783BD",
                    fontSize: 16
                }
            }
            this.option.series = [
                {
                    name: '微信',
                    type: 'pie',
                    radius: ['60%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '40',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: this.payMethodList,
                    freeRate: 0
                }
            ]
            this.echartsPie = echarts.init(document.getElementById('gatheringMain'))
            this.option && this.echartsPie.setOption(this.option);
            this.fun_date(-6)
            this.getStatisticsOrdersByDates(this.sevenDate, this.nowDate)
            this.pieActive(this.echartsPie)
            this.echartsPie.on('mouseout',()=>{
              this.pieActive(this.echartsPie)
            })
        },
        getOrderNumsByStatus() {
            getOrderNumsByStatus({
                orderCategory: 3
            })
            .then(res => {
                this.getAllOrdersSimple()
                this.orderList1 = []
                if (res.code == 1) {
                   this.orderList1 = JSON.parse(JSON.stringify(res.data))
                    res.data.forEach(item => {
                        if (item.orderStatus == 0) {
                            this.total = item.orderNum
                        }
                        var index = this.orderList1.findIndex(ele => {
                            return (ele.orderStatus == '-10' || ele.orderStatus == '0' || ele.orderStatus == '-20')
                        })
                        // console.log(index)
                        if (index !== -1) {
                            this.orderList1.splice(index, 1)
                        }
                    })
                    // console.log(this.orderList1, "orderList1")
                }
            })
        },
        getAllOrdersSimple() {
            getAllOrdersSimple({
                orderCategory: 3
            })
            .then(res => {
                if (res.code == 1) {
                    this.orderList = JSON.parse(JSON.stringify(res.data))
                    res.data.forEach(item => {
                        var index = this.orderList.findIndex(ele => {
                            return ele.orderStatus == '-10'
                        })
                        console.log(index)
                        if (index !== -1) {
                            this.orderList.splice(index, 1)
                        }
                    })
                }
            })
        },
        // 订单趋势
        getStatisticsOrdersByDates(startDate, endDate) {
            getStatisticsOrdersByDates({
                startDate,
                endDate
            })
            .then(res => {
                this.getOrderNumsByStatus()
                if (res.code == 1) {
                    this.orderOption.xAxis.data = []
                    let list = []
                    let list1 = []
                    let arr = res.data.map(item => {
                        return item.orderDate.substring(5, 10)
                    })
                    console.log(arr, 123)
                    arr.forEach(ele => {
                        this.orderOption.xAxis.data.push(ele)
                    })
                    res.data.forEach(item => {
                        list.push(item.orderNum)
                        list1.push(item.orderNum)
                    })
                    this.orderOption.series = [
                        {
                            // name: '平均温度',
                            type: 'bar',
                            // yAxisIndex: 0,
                            data: list,
                            label: {   //  显示数值
                                show: true,
                                position: 'top',
                                color: '#fff',
                                fontSize: 14,
                                fontWeight: 500
                            },
                            itemStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#5DCCF7'
                                }, {
                                    offset: 1,
                                    color: '#418DE2'
                                }]),
                            }
                        },
                        {
                            // name: '平均温度',
                            type: 'line',
                            yAxisIndex: 0,
                            data: list1
                        }
                    ]
                    this.getOrderTrend()
                }
            })
        },
        // 123
        getOrderTrend() {
            // if (this.orderEchartsPie != null && this.orderEchartsPie != "" && this.orderEchartsPie != undefined) {
            //     this.orderEchartsPie.dispose();//销毁
            // }
            this.orderEchartsPie = echarts.init(document.getElementById('orderMain'))
            this.orderOption && this.orderEchartsPie.setOption(this.orderOption);
            this.getAccessRecordForStatistics(this.sevenDate, this.nowDate)
        },
        // 访问趋势统计
        getAccessRecordForStatistics(startDate, endDate) {
            getAccessRecordForStatistics({
                startDate,
                endDate,
                shopId: localStorage.shopId
            })
            .then(res => {
                if (res.code == 1) {
                    this.polylineOption.xAxis.data = []
                    this.polylineOption.series[0].data = []
                    let arr = res.data.map(item => {
                        return item.accessDate.substring(5, 10)
                    })
                    // console.log(arr, 123456)
                    arr.forEach(ele => {
                        this.polylineOption.xAxis.data.unshift(ele)
                    })
                    res.data.forEach(item => {
                        // this.polylineOption.xAxis.data.unshift(item.accessDate)
                        this.polylineOption.series[0].data.unshift(item.accessNum)
                    })
                    this.getVisitTrend()
                }
            })
        },
        // 123
        getVisitTrend() {
            // if (this.polylineEcharts != null && this.polylineEcharts != "" && this.polylineEcharts != undefined) {
            //     this.polylineEcharts.dispose();//销毁
            // }
            this.polylineEcharts = echarts.init(document.getElementById('visitMain'))
            this.polylineOption && this.polylineEcharts.setOption(this.polylineOption);
        },
        // 会员统计数据
        getShopMemberData() {
            getShopMemberData()
            .then(res => {
                if (res.code == 1) {
                    this.shopMemberData = res.data
                    this.memberChangeList = []
                    this.memberChangeList = [
                        { memberNum: this.shopMemberData.total_member_num, operateName: "会员总数" },
                        { memberNum: this.shopMemberData.today_activation_num, operateName: "当日新增" },
                        { memberNum: this.shopMemberData.total_member_balance, operateName: "储值余额" },
                        { memberNum: this.shopMemberData.today_total_consume, operateName: "当日消费" }
                    ]
                    this.getFindDailyNewShopMemberNum(this.sevenDate, this.nowDate)
                }
            })
        },
        // 每日的会员注册数量
        getFindDailyNewShopMemberNum(startDate, endDate ) {
            getFindDailyNewShopMemberNum({
                startDate,
                endDate 
            })
            .then(res => {
                if (res.code == 1) {
                    this.polylineOption.xAxis.data = []
                    this.polylineOption.series[0].data = []
                    // console.log(res.data)
                    let arr = res.data.map(item => {
                        return item.date.substring(5, 10)
                    })
                    // console.log(arr, 123456)
                    arr.forEach(ele => {
                        this.polylineOption.xAxis.data.unshift(ele)
                    })
                    res.data.forEach(item => {
                        this.polylineOption.series[0].data.unshift(item.shopMemberNum)
                    })
                    this.getMemberData()
                }
            })
        },
        // 123
        getMemberData() {
            // if (this.polylineEcharts1 != null && this.polylineEcharts1 != "" && this.polylineEcharts1 != undefined) {
            //     this.polylineEcharts1.dispose();//销毁
            // }
            this.polylineEcharts1 = echarts.init(document.getElementById('memberMain'))
            this.polylineOption && this.polylineEcharts1.setOption(this.polylineOption);
        },
        // 桌位列表含状态
        getShopTablesForCockpit() {
            getShopTablesForCockpit({
                pageNo: 1,
                row: 999
            })
            .then(res => {
                if (res.code == 1) {
                    this.tableList = res.data
                } else if (res.code == -1) {
                    this.tableList = []
                }
            })
        },
        getEdcShopTablesNumsV2() {
            getEdcShopTablesNumsV2()
            .then(res => {
                if (res.code == 1) {
                    this.tableStatusNum = []
                    this.freeRate = 0
                    let total = 0
                    let num = 0
                    res.data.forEach((item => {
                        let colors = item.status == 0 ? '#69E2E1' : item.status == 1 ? '#FF3B30' : item.status == 100 ? '#6001FF' : item.status == 3 ? '#418DE2' : '';
                        this.tableStatusNum.push({
                            value: item.num,
                            name: item.status == 0 ? '空闲' : item.status == 1 ? '占用' : item.status == 100 ? '预约' : item.status == 3 ? '结账' : item.status == 2 ? '占用' : '',
                            itemStyle: { color: colors }
                        })
                        total += item.num
                        if (item.status == 0) {
                            num = item.num 
                        }
                    }))
                    this.freeRate = (num / total).toFixed(2) * 100
                    // console.log(this.freeRate, "this.freeRate")
                    // console.log(this.tableStatusNum, "this.tableStatusNum")
                    this.getTableStatus()
                }
            })
        },
        // 123
        getTableStatus() {
            // if (this.tableStatusEchartsPie != null && this.tableStatusEchartsPie != "" && this.tableStatusEchartsPie != undefined) {
            //     this.tableStatusEchartsPie.dispose();//销毁
            // }
            this.option.legend = {
                orient: 'horizontal',
                x: 'center',
                y: 'bottom',
                // x: '0',
                // y: '270px',
                itemWidth: 14,   // 设置图例图形的宽
                itemHeight: 14,  // 设置图例图形的高
                textStyle: {
                    color: '#5783BD'  // 图例文字颜色
                },
                data: ["空闲", "结账", "占用", "预约"],
                itemGap: 30,
            }
            this.option.graphic = {
                type:"text",
                left:"center",
                top:"45%",
                style:{
                    text: `${this.freeRate}%`,
                    textAlign:"center",
                    fill:" #fff",
                    fontSize: 28
                }
            }
            this.option.title = {}
            this.option.series = [
                {
                    name: '',
                    type: 'pie',
                    radius: ['65%', '45%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '40',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: this.tableStatusNum
                }
            ]
            this.tableStatusEchartsPie = echarts.init(document.getElementById('tableStatusMain'))
            this.option && this.tableStatusEchartsPie.setOption(this.option);
            this.getStatisticsComments()
            this.pieActive(this.tableStatusEchartsPie)
            this.tableStatusEchartsPie.on('mouseout',()=>{
              this.pieActive(this.tableStatusEchartsPie)
            })
        },
        // 评论统计 （总评价数=各评分评价数相加）
        getStatisticsComments() {
            getStatisticsComments()
            .then(res => {
                if (res.code == 1) {
                    this.commonNumList = []
                    this.commonNumList = res.data.shopScoreItem
                    this.scoreRate = res.data.info.shopScore
                    // this.commonNumList = [
                    //     { commentNum: 30, shopScore: 5 },
                    //     { commentNum: 12, shopScore: 4 },
                    //     { commentNum: 14, shopScore: 1 },
                    //     { commentNum: 16, shopScore: 2 },
                    //     { commentNum: 29, shopScore: 3 }
                    // ]
                    let a = this.commonNumList
                    for (var i = 0; i < a.length; i++) {
                        for (var j = i + 1; j < a.length; j++) {
                            if (a[i].shopScore > a[j].shopScore) {
                                var tmp = a[i].shopScore;
                                a[i].shopScore = a[j].shopScore;
                                a[j].shopScore = tmp;
                            }
                        }
                    }
                    // console.log(this.commonNumList, 123)
                    this.getTotalRate()
                }
            })
        },
        // 123
        getTotalRate() {
            // if (this.totalRateEchartsPie != null && this.totalRateEchartsPie != "" && this.totalRateEchartsPie != undefined) {
            //     this.totalRateEchartsPie.dispose();//销毁
            // }
            let commonNumList = []
            this.totalCommonNum = 0
            this.commonNumList.forEach(item => {
                let colors = item.shopScore == 1 ? '#FF3B30' 
                    : item.shopScore == 2 ? '#F29900' 
                    : item.shopScore == 3 ? '#69E2E1' 
                    : item.shopScore == 4 ? '#418DE2'
                    : item.shopScore == 5 ? '#6001FF'
                    : ''
                commonNumList.push({
                    value: item.commentNum,
                    name: item.shopScore + '星',
                    itemStyle: { color: colors }
                })
                this.totalCommonNum += item.commentNum
            })
            // this.option.legend = {
            //     orient: 'horizontal',
            //     x: 'left',
            //     y: 'bottom',
            //     // x: '60px',
            //     // y: '234px',
            //     itemWidth: 24,   // 设置图例图形的宽
            //     itemHeight: 18,  // 设置图例图形的高
            //     textStyle: {
            //         color: '#5783BD'  // 图例文字颜色
            //     },
            //     data: ["1星", "2星", "3星", "4星", "5星"],
            //     itemGap: 30,
            // }
            this.option.graphic = {
                type:"text",
                left: 'center',
                top:'50%',
                style:{
                    text: this.scoreRate,
                    textAlign:"center",
                    fill:" #fff",
                    fontSize: 28
                }
            }
            this.option.title = {}
            this.option.series = [
                {
                    name: '',
                    type: 'pie',
                    radius: ['85%', '70%'],
                    center: ['58%', '55%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '40',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    // itemStyle: {
                    //     color: function(params) {
                    //         var colorList = ['#FF3B30', '#F29900', '#69E2E1', '#418DE2', '#6001FF'];
                    //         return colorList[params.dataIndex]
                    //     }
                    // },
                    data: commonNumList
                }
            ]
            this.totalRateEchartsPie = echarts.init(document.getElementById('totalRateMain'))
            this.option && this.totalRateEchartsPie.setOption(this.option);
            this.getFindReceiveOrWriteOffStatictic()
            this.pieActive(this.totalRateEchartsPie)
            this.totalRateEchartsPie.on('mouseout',()=>{
              this.pieActive(this.totalRateEchartsPie)
            })
        },
        // 统计券领取数量和核销数量
        getFindReceiveOrWriteOffStatictic() {
            this.fun_date(-6)
            // console.log(this.nowDate, "nowDate", this.sevenDate, "nowDate");
            getFindReceiveOrWriteOffStatictic({
                startDate: this.sevenDate,
                endDate: this.nowDate
            })
            .then(res => {
                if (res.code == 1) {
                    this.couponList = res.data
                    this.getCouponEcharts()
                }
            })
        },
        // 123
        getCouponEcharts() {
            // if (this.couponEchartsPie != null && this.couponEchartsPie != "" && this.couponEchartsPie != undefined) {
            //     this.couponEchartsPie.dispose();//销毁
            // }
            this.option.title = {
                text: this.couponList.writeoffNum,
                left: 'center',
                top:'35%',
                textStyle:{
                  color:'#fff',
                  fontSize: 20,
                  align:'center'
                }
            }
            this.option.graphic = {       // 图形中间文字
                type:"text",
                left:"32%",
                top:"55%",
                style:{
                    text:"核销数量",
                    textAlign:"center",
                    fill:"#5783BD",
                    fontSize: 16
                }
            }
            this.option.series = [
                {
                    name: '',
                    type: 'pie',
                    radius: ['85%', '70%'],
                    center: ['54%', '50%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '40',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        {value: this.couponList.writeoffNum, name: '核销数量', itemStyle: { color: '#FF3B30' }},
                        {value: this.couponList.receiveNum, name: '领取数量', itemStyle: { color: '#418DE2' }}
                    ]
                }
            ]
            this.couponEchartsPie = echarts.init(document.getElementById('couponMain'))
            this.option && this.couponEchartsPie.setOption(this.option);
            this.pieActive(this.couponEchartsPie)
            this.couponEchartsPie.on('mouseout',()=>{
              this.pieActive(this.couponEchartsPie)
            })
        },
        pieActive(echartsPies) {
            let echartsPie = echartsPies
            let index = -1 //高亮所在下标
            let dataLength = this.option.series[0].data.length   // 当前饼图有多少个扇形
            // console.log(dataLength, "dataLength")
            this.mTime = setInterval(()=>{
                // 清除之前的高亮
                echartsPie.dispatchAction({
                    type: 'downplay',
                    seriesIndex: 0,
                    dataIndex: index
                })
                index = (index + 1) % dataLength
                // 当前下标高亮
                echartsPie.dispatchAction({
                    type: 'showTip',
                    // type: 'highlight',
                    seriesIndex: 0,
                    dataIndex: index
                })
                if (index > dataLength) {
                  index = 0
                }
            }, 5000)
            // 鼠标划入
            echartsPie.on('mouseover',()=>{
              // 停止定时器，清除之前的高亮
              clearInterval(this.mTime)
              this.echartsPie.dispatchAction({
                type: 'downplay',
                seriesIndex: 0,
                dataIndex: index
              })
            })
        },
    }
}
</script>

<style lang="less">
.BMap_cpyCtrl {
    display: none;
}
.anchorBL {
    display: none;
}
</style>
<style lang="less" scoped>
/deep/ .el-progress-bar__inner {
    background: linear-gradient(270deg, #5DCCF7 0%, #418DE2 100%);
    border-radius: 6px;
}
/deep/ .el-progress {
    padding-top: 12px;
    box-sizing: border-box;
}
/deep/ .el-progress-bar__outer {
    background: #132448;
    border-radius: 6px;
}
.pb10 {
  padding-bottom: 10px;
  box-sizing: border-box;
}
.pl12 {
  padding-left: 12px;
  box-sizing: border-box;
}
.pl5 {
  padding-left: 5px;
  box-sizing: border-box;
}
.pr10 {
  padding-right: 10px;
  box-sizing: border-box;
}
.pl10 {
  padding-left: 10px;
  box-sizing: border-box;
}
.pt10 {
  padding-top: 10px;
  box-sizing: border-box;
}
.pt35 {
  padding-top: 35px;
  box-sizing: border-box;
}
.padding20 {
    padding: 20px;
    box-sizing: border-box;
}
.content-page {
    background-color: #020719;
    width: 100%;
    height: 100%;
    display: flex;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    color: #fff;
    .sale-date {
        cursor: pointer;
        .item {
            font-weight: 500;
            color: #418DE2;
            font-size: 16px;
            width: 38px;
            line-height: 30px;
            text-align: center;
            &.active {
                width: 38px;
                height: 30px;
                background: #418DE2;
                border-radius: 20px;
                color: #fff;
            }
        }
    }
    .circle {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-top: 5px;
        &.red {
            background: #FF3B30;
        }
        &.orange {
            background: #F29900;
        }
        &.blue {
            background: #69E2E1;
        }
        &.deepBlue {
            background: #418DE2;
        }
        &.purple {
            background: #6001FF;
        }
    }
    .lengendSize {
        color: #5783BD;
        font-size: 14px;
    }
    .totalNum {
        font-weight: 500;
        color: #5783BD;
        line-height: 20px;
        box-sizing: border-box;
        padding-left: 30px;
        font-size: 16px;
    }
    .circleImg {
        width: 21px;
        height: 21px;
        vertical-align: middle;
    }
    .data-title {
        box-sizing: border-box;
        padding-left: 10px;
        font-weight: bold;
        font-size: 18px;
    }
    .left-part {
        width: 25%;
        height: 100%;
        padding: 30px 20px;
        box-sizing: border-box;
        .coupon-data {
            width: 100%;
            height: 204px;
            background: #0F1836;
            border-radius: 32px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            #couponMain {
                width: 35%;
                height: 100%;
            }
        }
        .composite-data {
            width: 100%;
            height: 230px;
            background: #0F1836;
            border-radius: 32px;
            margin: 20px 0;
            position: relative;
            #totalRateMain {
                width: 35%;
                height: 100%;
            }
            .rate-legend {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
            }
        }
        .member-data {
            width: 100%;
            height: 540px;
            background: #0F1836;
            border-radius: 32px;
            .memberNum-change {
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin-top: 20px;
                .change-area {
                    width: 50%;
                    &:nth-child(3) {
                        margin-top: 15px;
                    }
                    &:nth-child(4) {
                        margin-top: 15px;
                    }
                    .memberNum {
                        font-size: 30px;
                        font-family: NeoSans-Bold, NeoSans;
                        font-weight: bold;
                    }
                    .operateName {
                        font-size: 14px;
                        font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                        font-weight: bold;
                        color: #5783BD;
                        line-height: 25px;
                    }
                }
            }
            .newAdd-echarts {
                width: 100%;
                height: 55%;
                margin-top: 20px;
                #memberMain {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .center-part{
        width: 50%;
        height: 100%;
        padding: 30px 20px;
        box-sizing: border-box;
        .shop-header {
            width: 100%;
            height: 114px;
            background: linear-gradient(360deg, #0F1836 0%, #1E2F4D 100%);
            border-radius: 32px;
            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
            font-weight: bold;
            color: #FFFFFF;
            padding: 30px;
            box-sizing: border-box;
            .shopName {
                font-size: 24px;
                padding-right: 10px;
                box-sizing: border-box;
                max-width: 274px;
            }
            .shopNames {
                font-size: 30px;
                padding-left: 10px;
                box-sizing: border-box;
            }
            .date {
                font-weight: 500;
                font-size: 16px;
            }
            .time {
                font-size: 24px;
                text-align: right;
            }
            .shopAddress {
                width: 72px;
                height: 36px;
                background: rgba(44, 88, 148, 0.4);
                border-radius: 8px;
                font-size: 16px;
                line-height: 36px;
                text-align: center;
            }
            .weihuoImg {
                width: 38px;
                height: 44px;
                vertical-align: middle;
            }
        }
        .shop-data {
            width: 100%;
            height: 74px;
            padding: 10px;
            box-sizing: border-box;
            margin-top: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .turnover {
                font-size: 30px;
                font-family: NeoSans-Bold, NeoSans;
                font-weight: bold;
                color: #FFFFFF;
                text-shadow: 0px 8px 12px rgba(0, 0, 0, 0.5);
            }
            .money {
                font-size: 15px;
                font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                font-weight: bold;
                color: #5783BD;
                text-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
                text-align: center;
            }
        }
        .data-exhibixion {
            width: 100%;
            height: 296px;
            margin-top: 10px;
            box-sizing: border-box;
            padding: 10px 20px;
            .box {
                width: 39%;
                height: 296px;
                overflow: auto;
                &::-webkit-scrollbar {
                  display: none;
                }
            }
            .box1 {
                width: 59%;
                height: 296px;
                overflow: auto;
                &::-webkit-scrollbar {
                  display: none;
                }
            }
            .goodsCase {
                width: 100%;
                height: 40px;
                line-height: 40px;
                border-radius: 20px;
                color: #fff;
                font-size: 14px;    
                cursor: pointer;
                padding: 0 10px;
                box-sizing: border-box;
                &.bg {
                    background: #132448;
                }
            }
            .table-status {
                width: 100%;
                height: 265px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin-bottom: 10px;
                overflow: auto;
                &::-webkit-scrollbar {
                  display: none;
                }
                .tableNum {
                    width: 77px;
                    height: 72px;
                    background: #fff;
                    border-radius: 12px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    line-height: 72px;
                    font-size: 18px;
                    // color: #fff;
                    font-family: NeoSans-Bold, NeoSans;
                    font-weight: bold;
                    color: #0F1836;
                    text-align: center;
                    overflow: hidden;
	                text-overflow: ellipsis;
	                white-space: nowrap;
                    box-sizing: border-box;
                    padding: 0 10px;
                    &.reserve {
                        background: #4992FF;
                    }
                    &.free {
                        background: #fff;
                        color: #0F1836;
                    }
                    &.checkOut {
                        background: #39D28A;
                        color: #0F1836;
                    }
                    &.occupy {
                        background: #FF3B30;
                    }
                }
            }
            .total-tableNum {
                font-weight: bold;
                color: #5783BD;
                line-height: 25px;
                font-size: 14px;
            }
            .table-status1 {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                color: #5783BD;
                .status {
                    margin-right: 60px;
                }
                .status.reserve {
                    margin-right: 15px;
                    &::before {
                        display: inline-block;
                        content: "";
                        border: 6px solid #4992FF;
                        border-radius: 50%;
                        margin-right: 8px;
                        clear: both;
                    }
                }
                .free {
                    &::before {
                        display: inline-block;
                        content: "";
                        border: 6px solid #fff;
                        border-radius: 50%;
                        margin-right: 8px;
                        clear: both;
                    }
                }
                .checkOut {
                    &::before {
                        display: inline-block;
                        content: "";
                        border: 6px solid #39D28A;
                        border-radius: 50%;
                        margin-right: 8px;
                        clear: both;
                    }
                }
                .occupy {
                    &::before {
                        display: inline-block;
                        content: "";
                        border: 6px solid #FF3B30;
                        border-radius: 50%;
                        margin-right: 8px;
                        clear: both;
                    }
                }
            }
        }
        .method-toggle {
            width: 280px;
            height: 80px;
            background: rgba(25, 50, 83, 0.6);
            border-radius: 32px;
            margin: 30px auto;
            font-size: 24px;
            color: #5783BD;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            box-sizing: border-box;
            padding: 0 20px;
            cursor: pointer;
            .item {
                line-height: 80px;
                &.active {
                    border-bottom: 3px solid #418DE2;
                    color: #FFFFFF;
                }
            }
        }
        .data-echarts {
            width: 100%;
            height: 370px;
            display: flex;
            .sale-data {
                color: #fff;
                width: 33%;
                height: 100%;
                background: #0F1836;
                padding: 15px 10px;
                box-sizing: border-box;
                &:nth-child(2) {
                    margin: 0 15px;
                }
                .sale-records {
                    width: 100%;
                    height: 83%;
                    margin-top: 10px;
                    overflow: auto;
                    &::-webkit-scrollbar {
                      display: none;
                    }
                    .sale-goods {
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        background: #132448;
                        border-radius: 25px;
                        display: flex;
                        margin: 10px 0;
                        .sequenceNum {
                            width: 30px;
                            height: 30px;
                            line-height: 30px;
                            text-align: center;
                            background: rgba(65, 141, 226, 0.7);
                            border-radius: 16px;
                            margin: 5px 30px 0 5px;
                        }
                    }
                    .sale-goods1 {
                        padding: 0 10px;
                        box-sizing: border-box;
                        &:first-child {
                            margin-top: 0;
                        }
                    }
                }
                .table-header {
                    font-weight: 500;
                    color: #5783BD;
                    padding-top: 5px;
                    box-sizing: border-box;
                    padding: 5px 10px 0 10px;
                    box-sizing: border-box;
                }
                #tableStatusMain {
                    width: 100%;
                    height: 100%;
                    margin-top: -25px;
                }
            }
        }
    }
    .right-part {
        width: 25%;
        height: 100%;
        padding: 30px 20px;
        box-sizing: border-box;
        .gathering-data {
            width: 100%;
            height: 335px;
            background: #0F1836;
            border-radius: 32px;
            #gatheringMain {
                width: 100%;
                height: 285px;
            }
        }
        .trend-chart {
            width: 100%;
            height: 320px;
            background: #0F1836;
            border-radius: 32px;
            margin: 20px 0;
            #orderMain {
                width: 100%;
                height: 285px;
            }
            #visitMain {
                width: 100%;
                height: 245px;
            }
        }
    }
}
</style>